<template>
	<div id="page_contact">

		<Header></Header>

		<div id="banner">
			<img class="pcShow" :src="imgPrefix + 'static/contact_banner.jpg'" />
			<img class="mobileShow" :src="imgPrefix + 'static/mobile_contact_banner.jpg'" />
		</div>

		<div id="contact">
			<div class="container">
				<div class="contact">
					<div class="title">联系我们</div>
					<div class="msg">
						<ul>
							<li>
								<img :src="imgPrefix + 'static/contact_icon1.jpg'" />
								<div class="txt">
									<p class="p1">服务热线</p>
									<p class="p2">+86-752-6383576</p>
								</div>
							</li>
							<li>
								<img :src="imgPrefix + 'static/contact_icon2.jpg'" />
								<div class="txt">
									<p class="p1">传真号码</p>
									<p class="p2">0752-6383584</p>
								</div>
							</li>
							<li>
								<img :src="imgPrefix + 'static/contact_icon3.jpg'" />
								<div class="txt">
									<p class="p1">邮件传送</p>
									<p class="p2">print@ds-cy.com</p>
								</div>
							</li>
							<li>
								<img :src="imgPrefix + 'static/contact_icon4.jpg'" />
								<div class="txt">
									<p class="p1">在线客服</p>
									<p class="p2">服务时间：9:00-18:00</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="mobileShow mobile_join">
			<div class="container">
				<div class="title">人才招聘</div>
				<div class="join">
					<div class="hd">
						<span :class="activeClass == index ? 'active':''" v-for="(item,index) in itemList" :key="index"
						@click="getItem(index)">{{item.text}}</span>
					</div>
					<div class="bd">
						<ul>
							<li :class="activeClass == 0 ? 'active':''">
								<h2>业务跟单员(2名)</h2>
								<div>
									<p>工作地点：广东惠州博罗</p>
									<p>性别：不限</p>
									<p>学历：中专及以上</p>
									<p>工作经验：三年</p>
									<p>职位描述与要求：男女不限，20至35周岁，2年以上相关工作经验，熟悉印刷工艺流程，有良好的统筹和沟通能力，能吃苦耐劳、有进取心。</p>
								</div>
							</li>
							<li :class="activeClass == 1 ? 'active':''">
								<h2>小森机三手(2名)</h2>
								<div>
									<p>工作地点：广东惠州博罗</p>
									<p>性别：男</p>
									<p>学历：初中及以上</p>
									<p>职位描述与要求：</p>
									<p>1、操作小森机一上以上工作经验；</p>
									<p>2、富有团队精神，工作主动、积极、有责任心，服从公司安排。</p>
								</div>
							</li>
							<li :class="activeClass == 2 ? 'active':''">
								<h2>手动啤机机长(2名)</h2>
								<div>
									<p>工作地点：广东惠州博罗</p>
									<p>性别：男</p>
									<p>学历：不限</p>
									<p>职位描述与要求：1年以上工作经验，熟练操作啤机，能独立完成装、较版，工作认真负责，能服从工作安排。</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="jobs pcShow" id="jobs">
			<div class="title">人才招聘</div>
			<div class="container">
				<ul>
					<li>
						<span>招聘职位</span>
						<span>工作地点</span>
						<span>性别</span>
						<span>学历</span>
						<span>工作经验</span>
						<span>职位描述与要求</span>
					</li>
					<li>
						<span>业务跟单员(2名)</span>
						<span>广东惠州博罗</span>
						<span>不限</span>
						<span>中专及以上</span>
						<span>三年</span>
						<span>男女不限，20至35周岁，2年以上相关工作经验，熟悉印刷工艺流程，有良好的统筹和沟通能力，能吃苦耐劳、有进取心。</span>
					</li>
					<li>
						<span>小森机三手(2名)</span>
						<span>广东惠州博罗</span>
						<span>男</span>
						<span>初中及以上</span>
						<span>一年</span>
						<span>操作小森机一上以上工作经验；<br>富有团队精神，工作主动、积极、有责任心，服从公司安排。</span>
					</li>
					<li>
						<span>手动啤机机长(2名)</span>
						<span>广东惠州博罗</span>
						<span>男</span>
						<span>不限</span>
						<span>一年</span>
						<span>1年以上工作经验，熟练操作啤机，能独立完成装、较版，工作认真负责，能服从工作安排。</span>
					</li>
				</ul>
			</div>
		</div>

		<div class="contact_address">
			<div class="container">
				<div class="address">
					<div class="title">联系地址</div>
					<div class="baiduMap">
						<div id="dsmap"></div>
						<div class="address">联系地址：广东省惠州市博罗县龙溪镇夏岗路189号得胜创业园</div>
					</div>
				</div>

				<div class="message">
					<div class="title">在线留言</div>
					<form>
						<div class="inp">
							<div class="inp_name">
								<div class="label">*</div><input id="msg_create_user" name="msg_create_user" type="text" class="name inp_text" placeholder="姓名" />
							</div>
							<div class="inp_contact">
								<div class="label">*</div><input id="msg_contact" name="msg_contact" type="text" class="contact inp_text" placeholder="联系方式" />
							</div>
						</div>
						<div class="inp">
						  <div class="inp_title">
							<div class="label">*</div><input id="msg_title" name="msg_title" type="text" class="ititle inp_text" placeholder="标题" />
						  </div>
						</div>
						<div class="inp inp2">
							<div class="label">*</div>
							<textarea id="msg_content" name="msg_content" class="textarea"></textarea>
						</div>
						<input type="button" value="提交" class="submit" @click="handleMessage" />
					</form>
				</div>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';

  import { saveMessage } from '../axios/api';
  import { loadJs  } from '../axios/fetch';

	export default {
    data() {
      return {
        imgPrefix: process.env.PREFIX_IMG,
        itemList:[
          {text:'推荐职位'},
          {text:'急聘职位'},
          {text:'热门职位'}
        ],
		    activeClass:"0",
        submitLoad: false,
        temp: {
          msg_create_user: '',
          msg_contact: '',
          msg_title: '',
          msg_content: ''
        },
      }
    },
		components: {
			Header,
			Footer
		},
    watch: {
      $route() {
        this.$nextTick(() => { this.getContactAnchor()});
      }
    },
    created(){
      this.$nextTick(() => { this.getContactAnchor()});
    },
		mounted() {
      this.$nextTick(function () {
        window.addEventListener('scroll', this.handleScroll)
      })

		  this.ready();
		  $("#nav ul li:nth-child(6) a.parent").addClass("router-link-exact-active");
		},

		methods:{
      getContactAnchor(){
        let select = localStorage.getItem("anchorId");
        let elm = document.getElementById(select);
        if (select && elm) {
          elm.scrollIntoView(true);
          localStorage.setItem('anchorId', '')
        }
      },
			getItem:function(index){
				this.activeClass = index;
			},
			ready: function() {
        
            var map = new BMap.Map('dsmap');
            var poi = new BMap.Point(114.12599, 23.150502);
            map.centerAndZoom(poi, 19);
            map.enableScrollWheelZoom();
            var windowsWidth=document.body.clientWidth;
            if(windowsWidth<767){
              map.disableDragging()
            }
            var content = '<div style="margin:0;line-height:20px;padding:2px;">' +
              '地址：广东省惠州市博罗县龙溪镇夏岗路189号得胜创业园' +
              '</div>';
            var searchInfoWindow = null;
            searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
              title: "惠州得胜彩印有限公司",
              width: 260,
              height: 50,
              panel: "panel",
              enableAutoPan: true
            });
            var marker = new BMap.Marker(poi);
            marker.addEventListener("click", function (e) {
              searchInfoWindow.open(marker);
            })
            searchInfoWindow.open(marker);
            map.addOverlay(marker);
        
        
			},

      handleMessage() {
        this.temp.msg_create_user = $("#msg_create_user").val();
        this.temp.msg_contact = $("#msg_contact").val();
        this.temp.msg_title = $("#msg_title").val();
        this.temp.msg_content = $("#msg_content").val();

        if (!this.temp.msg_create_user || !this.temp.msg_contact || !this.temp.msg_title || !this.temp.msg_content) {
          alert("请完善留言信息");
        } else {
          saveMessage(this.temp).then(response => {
            alert("您的留言信息已成功提交");
            location. reload()
          }).catch(err => {
            alert("留言信息提交失败，请重试！");
          });
        }
      }
		}
	}
</script>

<style>
	.jobs{
		background: #eeeeee;
		padding-top: 65px;
		padding-bottom: 20px;
	}

	.jobs .title{
		font-size: 42px;
		color: #333333;
		position: relative;
		letter-spacing: 2px;
		margin-bottom: 40px;
		text-align: center;
	}

	.jobs ul{
		background: #fff;
	}

	.jobs ul li{
		padding: 35px 0;
		border-bottom: 1px solid #e4e4e4;
		min-height: 0;
		overflow: hidden;
		text-align: center;
	}

	.jobs ul li span{
		display: block;
		float: left;
		width: 15%;
	}

	.jobs ul li span:last-child{
		text-align: left;
		width: 36%;
		margin-left: 3%;
	}

	.jobs ul li span:first-child{
		text-align: left;
		color: #00a0e9 !important;
	}

	/* .jobs ul li:first-child */

	.jobs ul li:first-child span:first-child{
		color: #333 !important;
	}

	.jobs ul li:first-child span{
		font-weight: bold;
		color: #333333;
		font-size: 18px;

	}

	.jobs ul li:first-child{
		font-size: 20px;
		padding-bottom: 15px;
	}

	.jobs ul li span:first-child{
		color: #333333;
		padding-left: 50px;
	}

	.jobs ul li span:nth-child(2){
		width: 11%;
	}

	.jobs ul li span:nth-child(3){
		width: 11%;
	}

	.jobs ul li span:nth-child(4){
		width: 11%;
	}

	.jobs ul li span:nth-child(5){
		width: 11%;
	}



	.message .submit{
		width: 300px;
		height: 46px;
		border: none;
		background: #00a0e9;
		color: #fff;
		float: right;
		margin-right: 1%;
	}
	.message .textarea{
		width: 97.55%;
		height: 185px;
		border: 1px solid #dddddd;
		outline: none;
	}
	.BMapLib_SearchInfoWindow .BMapLib_bubble_title{
		font-family: "微软雅黑";
	}
	.BMapLib_bubble_content{
		font-family: "微软雅黑";
	}
	.inp{
		margin-bottom: 25px;
	}
	.inp_text{
		height: 40px;
		border:1px solid #dddddd;
		text-indent: 15px;
	}
	.inp_title {
		float: left;
		width: 100%;
		/*margin-right: 5%;*/
	}
  .inp_title input{
    width: 97.55%;
  }
	.inp_sex {
		float: left;
		position: relative;
		top: 8px;
	}
	.inp_sex label{
		cursor: pointer;
		font-size: 18px;
		color: #666666;
		margin-right: 25px;
	}
	.inp_name{
		width: 48%;
		float: left;
	}
	.inp_name input{
		width: 95%;
	}
	.inp_contact{
		width: 48%;
		float: right;
	}
	.inp_contact input{
		width: 95%;
	}
	.inp_name .name{
		width: 95%;
	}
	.message{
		background: #fff;
		margin-top: 60px;
		padding-bottom: 55px;
		margin-bottom: 80px;
		min-height: 0;
		overflow: hidden;
	}
	.message input{
		outline: none;
	}
	.message .inp{
		min-height: 0;
		overflow: hidden;
	}
	.message .inp_text::placeholder{
		color: #bdbdbd;
		font-size: 16px;
		text-indent: 15px;
	}
	.message .label{
		font-size: 18px;
		color: #e70f20;
		margin-right: 8px;
		display: block;
		float: left;
	}
	.message form{
		width: 80%;
		margin: auto;
	}
	.contact_address{
		min-height: 700px;
		overflow: hidden;
		background: #eeeeee;
	}
	.address{
		text-align: center;
	}

	.contact_address .title{
		font-size: 42px;
		color: #333333;
		position: relative;
		padding-top: 55px;
		letter-spacing: 2px;
		margin-bottom: 40px;
		text-align: center;
	}

	#contact{
		margin: 80px 0;
	}

	.contact .title{
		font-size: 42px;
		color: #333333;
		position: relative;
		padding-bottom: 20px;
		letter-spacing: 2px;
		margin-bottom: 58px;
		text-align: center;
	}

	.contact .msg{
		min-height: 0;
		overflow: hidden;
	}

	.contact .msg ul li{
		width: 25%;
		float: left;
	}

	.contact .msg ul li img{
		float: left;
		margin-right: 15px;
	}

	.contact .msg ul li .p1{
		font-size: 20px;
		color: #666666;
		margin-bottom: 6px;
		padding-top: 2px;
	}

	.contact .msg ul li .p2{
		font-size: 20.5px;
		color: #333333;
	}

	.baiduMap{
		width: 100%;
		height: 575px;
		position: relative;
	}

	.baiduMap .address{
		background: #434343;
		color: #fff;
		line-height: 80px;
		text-indent: 40px;
		text-align: left;
		font-size: 22px;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#dsmap {
		height: 100%;
		width: 100%;
		border: 4px solid #fff;
	}

	.BMapLib_SearchInfoWindow .BMapLib_nav{
	    display: none !important
	}

	.BMapLib_SearchInfoWindow .BMapLib_trans{
	    top: 81px !important
	}

	.BMapLib_SearchInfoWindow .BMapLib_bubble_tools .BMapLib_sendToPhone{
	    display: none !important
	}

	.BMapLib_SearchInfoWindow{
	  width: 230px !important;
	}

	.BMapLib_bubble_content{font-size: 14px }
	.BMapLib_bubble_title{font-size: 16px !important}
	.BMap_cpyCtrl{display: none}
	.anchorBL{display: none}
	.BMap_Marker img{
	  width: 39px
	}


	@media (max-width:1440px) {
		.jobs ul li span:first-child{
			padding-left: 35px;
		}
		.jobs ul li span{
			font-size: 15px;
		}
		.jobs ul li:first-child span{
		    font-size: 18px;
		}
	}

	@media (max-width:1199px) {
		.jobs ul li span:first-child{
			width: 18%;
		}
		.jobs ul li span:last-child{
			width: 34%;
		}
		.contact .msg ul li .p2{
			font-size: 16px;
		}
		.contact .msg ul li img{
			width: 55px;
		}
		.contact .msg ul li .p1 {
		    font-size: 18px;
		    margin-bottom: 3px;
		}
		.contact .title{
			font-size: 35px;
		}
		.contact_address .title{
			font-size: 35px;
		}

	}

	@media (max-width:991px) {
		.contact .msg ul li{
			width: 40%;
			margin-left: 10%;
		}
		.jobs ul li span:first-child{
			width: 23%;
			padding-left: 22px;
		}
		.jobs ul li span:last-child{
			width: 26%;
		}
		.jobs ul li span{
			font-size: 14.5px;
		}
		.jobs ul li span:nth-child(2) {
		    width: 13%;
		}
		.jobs ul li:first-child span {
		    font-size: 17px;
		}
		.baiduMap .address{
			line-height: 70px;
			text-indent: 30px;
			text-align: left;
			font-size: 18px;
		}
	}

	@media (max-width:767px) {
		.message .submit{
			width: 63%;
			margin-right: 16%;
			margin-top: 8px;
		}
		.message{
			margin-top: 25px;
			margin-bottom: 25px;
		}

		.contact .title{
			font-size: 24px;
			padding-bottom: 0;
			margin-bottom: 20px;
		}
		#contact {
		    margin: 30px 0;
			margin-bottom: 0;
		}
		.contact_address .title{
			font-size: 24px;
			margin-bottom: 20px;
			padding-top: 20px;
		}
		.ititle{
      width: 95% !important;
		}
		.inp_name{
			width: 100%;
			margin-bottom: 12px;
		}
		.inp_contact{
			width: 100%;
		}
		.message form{
			width: 90%;
		}
		.textarea{
			width: 100%;
			height: 160px;
			flex-direction: column;
		}
		.submit{
			width: 200px;
			float: initial;
			margin: auto;
			display: block;
		}
		.message{
			padding-bottom: 25px;
		}
		.inp {
		    margin-bottom: 12px;
		}
		.inp_sex label{
			font-size: 16px;
		}
		.inp_sex{
			top: 10px;
			margin-left: 20px;
		}
		.message .inp_text::placeholder{
			font-size: 15px;
		}
		.submit{
			height: 35px;
			font-size: 15px;
		}
		#page_contact{
			background: #eeeeee;
		}
		.contact .msg ul li{
			width: 49%;
			margin-right: 0;
			background: #fff;
			margin-bottom: 2%;
			border-radius: 5px;
			margin-left: 0;
		}
		.contact .msg ul li:nth-child(2n){
			float: right;
		}
		.contact .msg ul li img{
			width: 30px;
			margin-right: 5px;
			margin-left: 7%;
			margin-top: 33px;
		}
		.contact .msg ul li .p1{
			font-size: 11px;
			margin-bottom: 0;
		}
		.contact .msg ul li .p2{
			font-size: 11px;
			margin-bottom: 0;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.contact .msg ul li .txt{
			padding: 30px 5% 30px 0;
		}
		.contact .msg ul li:last-child .txt{
			padding-right: 0;
		}
		.baiduMap{
			height: 300px;
		}
		.baiduMap .address{
			line-height: 50px;
			text-indent: 3%;
			font-size: 12px;
		}
		#dsmap{
			border: 3px solid #fff;
		}

		.message .inp2{
			display: flex;
		}

		.inp_name{
			display: flex;
		}

		.inp_contact{
			display: flex;
		}

		.inp_title{
			display: flex;
		}

		.mobile_join{
			margin-top: 36px;
		}
		.mobile_join .join{
			background: #fff;
			padding-top: 20px;
		}
		.mobile_join .title{
			font-size: 24px;
			margin-bottom: 20px;
			text-align: center;
		}
		.mobile_join .hd{
			height: 35px;
			border-bottom: 1px solid #e4e4e4;
			padding: 0 20px 0 20px;
			min-height: 0;
			text-align: center;
		}
		.mobile_join .hd span{
			font-size: 15px;
			margin: 0 18px;
			display: inline-block;
			padding-bottom: 9px;
		}
		.mobile_join .hd span.active{
			border-bottom:2px solid #22adec;
			color: #22adec;
		}
		.mobile_join .bd{
			margin: 26px;
			min-height: 0;
			overflow: hidden;
			padding-bottom: 10px;
		}
		.mobile_join .bd li{
			display: none;
		}
		.mobile_join .bd li.active{
			display: block;
		}
		.mobile_join .bd h2{
			font-size: 18px;
			color: #00a0e9;
		}
		.mobile_join .bd p{
			font-size: 13px;
			color: #333333;
			margin-bottom: 5px;
		}
		.mobile_join .bd div{
			margin: 13px 0;
		}
	}

	@media (max-width:350px) {
		.mobile_join .hd span{
			font-size: 14px;
			margin: 0 12px;
		}
		.mobile_join .bd{
			margin: 20px;
		}
		.mobile_join .bd h2{
			font-size: 16px;
		}
		.message .textarea{
			height: 140px;
		}
		.contact .msg ul li .p2{
			font-size: 10px;
		}
		.contact .msg ul li img{
			width: 28px;
		}
	}

</style>




// WEBPACK FOOTER //
// src/page/contact.html.vue